/**
 * Easy way to add query parameters to the already correctly defined route
 * @param path
 * @param queryParams
 */
export function generateUrl(path: string, queryParams: object) {
    const params = new URLSearchParams();

    for (const entry of Object.entries(queryParams)) {
        params.append(entry[0], entry[1]);
    }

    return path + "?" + params.toString();
}
